import { createAsyncThunk } from '@reduxjs/toolkit'
import invoicesService from 'services/invoices'

export const getInvoices = createAsyncThunk(
	'invoices/get',
	invoicesService.getInvoices
)
